
import Footer from '../../components/feature/Footer';
import Header from '../../components/feature/Header';
import RegisterSection from './components/RegisterSection';


function Register() {
  return (
    <div className="min-h-screen">
      <Header />
      <main>
        <RegisterSection />
      </main>
      <Footer />
    </div>
  );
}

export default Register;
